import { Box, Button, Typography } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import EditIcon from "@mui/icons-material/Edit";
import ChangeOwnerProfileDetailsModal from "../../modals/ChangeOwnerProfileDetailsModal";
import React, { useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";

const CustomDocumentOwnerTab = ({ isReadOnlyPage = false }) => {
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const { selectedRow } = useSelector((state) => state.myPermitsComponent);

  const { signer } = selectedRow;

  const [modalOpen, setModalOpen] = useState(false);
  const [fieldValues, setFieldValues] = useState({
    ownerEmail: signer?.email || "",
    ownerMobile: signer?.phone_number || "",
    ownerEmailError: false,
    ownerMobileError: false,
  });
  const [fieldChangedText, setFieldChangedText] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChangeOwnerDetails = async () => {
    try {
      setLoading(true);
      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/building/update-owner-profile-info`,
        {
          task_id: selectedRow?.cst_packageID,
          newEmail: fieldValues?.ownerEmail,
          newMobile: fieldValues?.ownerMobile,
          currentSession: currentSession,
        },
        { withCredentials: true },
      );
      if (resp?.data?.success) {
        setFieldChangedText(resp?.data?.message);
        setTimeout(() => {
          setModalOpen(false);
          setFieldValues({
            ownerEmail: fieldValues?.ownerEmail,
            ownerMobile: fieldValues?.ownerMobile,
            ownerEmailError: false,
            ownerMobileError: false,
          });
          setLoading(false);
          setFieldChangedText("");
        }, 3000);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          mt: 1,
        }}
      >
        <img
          alt="house"
          src="/img/website_img/house.png"
          style={{
            width: "100%",
            maxWidth: "5rem",
            height: "auto",
            borderRadius: "20px",
          }}
        />

        <>
          <Typography mt={1} fontWeight="bold">
            {signer?.PERSON?.first_name} {signer?.PERSON?.last_name}
          </Typography>
          {selectedRow?.notarized ||
          selectedRow?.processing_permit?.notarization?.owner?.notarization
            ?.waiting_to_schedule ? (
            <></>
          ) : (
            !isReadOnlyPage && (
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Button
                  onClick={() => setModalOpen(true)}
                  startIcon={<EditIcon />}
                >
                  Edit Details
                </Button>
              </Box>
            )
          )}

          <Box mt={6}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                mb: 0.5,
              }}
            >
              <LocationOnIcon />
              <Typography>
                {selectedRow?.document_location?.primary_address ||
                  signer?.address}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                mb: 0.5,
              }}
            >
              <EmailIcon />
              <Typography>{signer?.email || "Unknown"}</Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                mb: 0.5,
              }}
            >
              <PhoneIcon />
              <Typography>{signer?.phone_number || "Unknown"}</Typography>
            </Box>
          </Box>
        </>
      </Box>
      <ChangeOwnerProfileDetailsModal
        open={modalOpen}
        setOpen={setModalOpen}
        onConfirm={handleChangeOwnerDetails}
        fieldValues={fieldValues}
        setFieldValues={setFieldValues}
        fieldChangedText={fieldChangedText}
        loading={loading}
        property_owner={signer}
      />
    </>
  );
};

export default React.memo(CustomDocumentOwnerTab);
